import { render, staticRenderFns } from "./PubListSubsection.vue?vue&type=template&id=6dc46f5d&scoped=true"
import script from "./PubListSubsection.vue?vue&type=script&lang=js"
export * from "./PubListSubsection.vue?vue&type=script&lang=js"
import style0 from "./PubListSubsection.vue?vue&type=style&index=0&id=6dc46f5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../imported/work/site/src/project/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc46f5d",
  null
  
)

export default component.exports